(function() {
	'use strict';

	angular
		.module('video')
		.component('videoplayer', {
			bindings: {
				mediaAutoplay: '<',
				mediaPath: '<',
				mediaPoster: '<',
				mediaText: '<',
				mediaType: '<',
				onEnd: '&',
				onPause: '&',
				onPlay: '&'
			},
			controller: 'VideoPlayerComponentController',
			controllerAs: 'vm',
			templateUrl: 'scripts/modules/video/components/video-player/video-player-component.html'
		});
}());